import { translate, type Translation } from "./lang.ts";
import { jadeEn } from "./tilecastle.en.ts";

/**
 * Lối Ngọc copy (Tile Castle). Same house style as vi.ts: warm and plain,
 * no dashes, dots, slashes, symbols or parentheses. English twin in
 * `tilecastle.en.ts`.
 */
const source = {
  left: (n: number) => `Còn ${n}`,
  goldLine: (n: number) => `Vạch vàng ${n}`,
  stuck: "Hết đường rồi nè! Hoàn tác vài bước hoặc chơi lại nha.",
  toThrone: "Sạch gạch rồi! Đi lên ngai vàng thôi nào.",
  hintCost: "Xài gợi ý thì màn này tối đa 2 sao thôi đó. Vẫn xài hông?",
  resultSatchel: (peak: number, tidiest: number) =>
    peak <= tidiest ? `Túi đầy nhất ${peak} viên, gọn y như đường đẹp nhất!` : `Túi đầy nhất ${peak} viên, đường gọn nhất chỉ cần ${tidiest} viên.`,
  resultRule: (gold: number) => `Ba sao khi túi không vượt vạch vàng ${gold} viên, hai sao khi lố đúng một viên.`,
  resultHint: "Có xài gợi ý nên tối đa 2 sao nha.",
};

export type JadeStrings = Translation<typeof source>;

export const jadeVi: JadeStrings = translate(source, jadeEn);
